export default [{  // 店铺资料
    path: 'shop_info',
    name: 'm_shop',
    component: () => import('@/pages/shop/info')
},{  // 预览店铺
    path: 'shop_view',
    name: 'm_shop_view',
    component: () => import('@/pages/shop/view')
},{  // 装修模板
    path: 'decorate_template',
	name: 'm_decoration',
	props: route => route.query,
    component: () => import('@/pages/shop/decorate_template')
}];